<template>
  <div class="home-layout-root" @click="over">
    <!-- 左侧菜单栏 -->
    <NavBar></NavBar>
    <!-- 头部 -->
    <HeadBar @mailboxClick="mailboxClick" @tasksClick="tasksClick" :mailboxTotal="mailboxTotal" :tasksTotal="tasksTotal" :language="language"></HeadBar>
    <!-- 内容 -->
    <MainContent v-loading="loding" :typeD="typeD" :typeTime="typeTime" @languageChange="languageChange"></MainContent>
    <Boyo-Dialog :dialogInfo="dialogInfo1"
                  @dialogEvent="dialogEvent1">
      <el-collapse v-model="activeName" accordion  @change="handleChange">
        <el-collapse-item v-for="(item,index) in mailboxDate" :key="index" :title="'标题：'+item.title" :name="index + 1" :class="item.readStatus?'mailboxOne':'mailboxTwo'">
          <div style="text-align: left;color:#636363">发件人：{{item.senderName}}，时间：{{item.createTime}}</div>
          <div style="text-align: left;color:#636363">内容：{{item.content}}</div>
        </el-collapse-item>
      </el-collapse>
    </Boyo-Dialog>
    <Boyo-Dialog :dialogInfo="dialogInfoTasks"
                  @dialogEvent="dialogEventTasks">
      <div class="top_item">
        <div class="left_title">
          <span style="float:left;margin-left:30px;font-weight:700">我的待处理事项</span>
          <span style="float:right;margin-right:15px;cursor:pointer">
            <i class="el-icon-refresh-right" @click="refreshMyPending"></i>
          </span>
        </div>
        <div v-loading="myPendingLoading">
          <div class="left_content_item bold">
            <el-row>
              <el-col :span="18">
                <span class="data_title_left">事项</span>
                </el-col>
              <el-col :span="6">
                <span class="data_title_right">数量</span>
              </el-col>
            </el-row>
          </div>
          <div class="left_content_item" @click="myAuditClick('')" style="cursor:pointer">
            <el-row>
              <el-col :span="18">
                <span class="data_title_left">我的待办审核</span>
              </el-col>
              <el-col :span="6">
                <span class="data_title_right">{{myAuditNumber?myAuditNumber:0}}</span>
              </el-col>
            </el-row>
          </div>
          <div class="left_content_item" v-for="(item,index) of numberList" :key="index" @click="myAuditClick(item.processDx,item)" style="cursor:pointer">
            <el-row>
              <el-col :span="18">
                <span class="data_title_left">{{item.name}}待办</span>
              </el-col>
              <el-col :span="6">
                <span class="data_title_right">{{item.number?item.number:0}}</span>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </Boyo-Dialog>
    <MyAudit-Dialog ref="MyAuditDialog" v-if="MyAuditDialogShow" @refresh="getMyPending" @approvalInfo="getMyPending"></MyAudit-Dialog>
  </div>
</template>

<script>
import NavBar from './NavBar/NavBar'
import HeadBar from './HeadBar/HeadBar'
import MainContent from './MainContent/MainContent'
import BoyoDialog from '@/components/BoyoDialog'
import BoyoForm from '@/components/BoyoForm'
import { mapState } from 'vuex'
import config from '@/api/config'
import MyAuditDialog from '@/components/Custom/MyAuditDialog'
export default {
  name: 'Home',
  components: {
    NavBar,
    HeadBar,
    MainContent,
    BoyoDialog,
    MyAuditDialog,
    BoyoForm
  },
  computed: {
    ...mapState({
      loding: state => state.app.loding
    })
  },
  props: {},
  data () {
    return {
      mailboxDate:[],
      mailboxTotal: 0,
      tasksDateDate:[],
      tasksTotal: 0,
      language:localStorage.languageName?localStorage.languageName:'中文',
      typeD:'0',
      typeTime:'157932468',
      activeName:'',
      numberList:[],
      myAuditNumber:'',
      myPendingLoading:false,
      MyAuditDialogShow:false,
      filterInfo: {
        visible: null, // 是否显示
        data: {
          pageNum:1,
          pageSize:50
        },
        list: [
        ]
      },
      dialogInfo1: {
        visible: false, // 弹框是否显示
        width: '800px', // 宽度
        title: {
          detail: "未读消息" // 标题
        },
        type: "detail", // 显示哪个标题
        // 按钮列表
        btList: [
          { label: '更多', type: '', icon: '', event: 'save', loading: false },
          { label: '关闭', type: '', icon: '', event: 'close', loading: false }
        ]
      },
      dialogInfoTasks: {
        visible: false, // 弹框是否显示
        width: '800px', // 宽度
        title: {
          detail: "我的审批待办" // 标题
        },
        type: "detail", // 显示哪个标题
        // 按钮列表
        btList: [
          // { label: '更多', type: '', icon: '', event: 'save', loading: false },
          { label: '关闭', type: '', icon: '', event: 'close', loading: false }
        ]
      },
    }
  },
  mounted(){
    // this.$api.system.getActProcessInstancePage({status:1,pageNum:1,pageSize:0,approverId:localStorage.userId,roleId:localStorage.roleId}).then(res => {
    //     if (res.code == 0) {
    //         this.tasksTotal = Number(res.data.total)
    //     }else{
    //         this.$message({ message: res.msg, type: 'error' })
    //     }
    // })
    // this.$api.Mailbox.getSysMessageReceivePage({status:1,pageNum:1,pageSize:999,readStatus:0}).then(res => {
    //   if (res.code == 0) {
    //       // this.mailboxDate = res.data.list
    //       this.mailboxTotal = Number(res.data.total)
    //   } else {
    //   }
    // })
    // this.$api.user.getUserTissueList({username:JSON.parse(localStorage.personal).userName}).then(res => {
    //   if (res.code == 0) {
    //     for(let i in res.data){
    //       this.listTypeInfo.tissueId.push({ value: res.data[i].id, label: res.data[i].tissueName})
    //     }
    //   }
    // })
    this.initWebSocket()
    window.addEventListener('beforeunload', this.websocketclose())
  },
  destroyed () { // 离开页面生命周期函数
    this.websocketclose();
  },
  methods: {
    over (event) {
      let myPanel = document.getElementById('myPanel')
      let dropdown = document.getElementById('dropdown-menu')
      let myTissue = document.getElementById('myTissue')
      if (myPanel && !myPanel.contains(event.target) && !dropdown.contains(event.target)) { // 这句是说如果我们点击到了id为myPanel以外的区域
        this.$store.commit('dropdownMenu', false)
      }
      // 选择商家弹窗挂载在 body 上，需排除弹窗区域再关闭
      if (myTissue && !myTissue.contains(event.target)) {
        const inTissueDialog = event.target.closest && event.target.closest('.tissue-merchant-select-dialog')
        if (!inTissueDialog) {
          this.$store.commit('dropdownTissue', false)
        }
      }
    },
    languageChange(val){
      this.language = val
    },
    initWebSocket: function () { // 建立连接
      // WebSocket与普通的请求所用协议有所不同，ws等同于http，wss等同于https
      var url = config.Websocket + '{' + localStorage.userId + '}';
      this.websock = new WebSocket(url);
      this.websock.onopen = this.websocketonopen;
      this.websock.send = this.websocketsend;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    // 连接成功后调用
    websocketonopen: function () {
      console.log("WebSocket连接成功");
    },
    // 发生错误时调用
    websocketonerror: function (e) {
      console.log("WebSocket连接发生错误");
    },
    // 给后端发消息时调用
    websocketsend: function (e) {
      console.log("WebSocket连接发生错误");
    },
    // 接收后端消息
    // vue 客户端根据返回的cmd类型处理不同的业务响应
    websocketonmessage: function (e) {
      var data = eval("(" + e.data + ")"); 
      console.log(data)
        //处理订阅信息
      if(data.type == '0'){
        //TODO 系统邮件消息
        this.$api.Mailbox.getSysMessageReceivePage({status:1,pageNum:1,pageSize:999,readStatus:0}).then(res => {
          if (res.code == 0) {
              // this.mailboxDate = res.data.list
              this.mailboxTotal = Number(res.data.total)
          } else {
            this.$message({ message: res.msg, type: 'error' })
          }
        })
        this.typeD = data.type+''
        this.typeTime = new Date().getTime()+''
      }else if(data.type == '1'){
          //TODO 司机数据大屏
        this.typeD = data.type+''
        this.typeTime = new Date().getTime()+''
      }
    },
    // 关闭连接时调用
    websocketclose: function (e) {
      console.log("WebSocket关闭");
      // console.log("connection closed (" + e.code + ")");
    },
    mailboxClick(val,lei){
      // console.log(lei)
     if (Number(lei) > 0) {
      this.dialogInfo1.visible = true
      this.$api.Mailbox.getSysMessageReceivePage({status:1,pageNum:this.filterInfo.data.pageNum,pageSize:this.filterInfo.data.pageSize,readStatus:0}).then(res => {
        if (res.code == 0) {
            this.mailboxDate = res.data.list
            this.mailboxTotal = Number(res.data.total)
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
      })
     }
    },
    tasksClick(val,lei){
      this.refreshMyPending()
      this.dialogInfoTasks.visible = true
    },
    refreshMyPending(){
      this.myPendingLoading = true
      this.$api.system.getActProcessInstancePage({status:1,pageNum:1,pageSize:0,approverId:localStorage.userId,roleId:localStorage.roleId}).then(res => {
          this.myPendingLoading = false
          if (res.code == 0) {
              this.myAuditNumber = Number(res.data.total)
              this.tasksTotal = Number(res.data.total)
          }else{
              this.$message({ message: res.msg, type: 'error' })
          }
      })
      this.$api.system.getProcessStatistic({approverId:localStorage.userId,roleId:localStorage.roleId}).then(res => {
          if (res.code == 0) {
              for(let iuy of res.data){
                iuy.processDx = iuy.processId.replace(/_/g, '').toUpperCase()
              }
              this.numberList = res.data
          }else{
              this.$message({ message: res.msg, type: 'error' })
          }
      })
    },
    myAuditClick(processDx,item){
      this.MyAuditDialogShow = true
      let type = '我的待办审核'
      if(processDx){
        type = item.name
      }
      this.$nextTick(()=>{
        this.$refs.MyAuditDialog.dialogShow(type,processDx)
      })
    },
    getMyPending(){
      this.refreshMyPending()
    },
    dialogEvent1 (event) {
      const dialogInfo1 = this.dialogInfo1
      switch (event) {
        case 'save':
          this.$router.push('/index/Editlog/Mailbox')
          dialogInfo1.visible = false
          break
        case 'close':
          dialogInfo1.visible = false
          break
      }
    },
    dialogEventTasks (event) {
      const dialogInfoTasks = this.dialogInfoTasks
      switch (event) {
        case 'close':
          dialogInfoTasks.visible = false
          break
      }
    },
    handleChange(){
      // console.log(this.activeName)
      if (this.activeName && this.mailboxDate[this.activeName - 1].readStatus == 0)
      this.$api.Mailbox.updateReadStatus({ id:this.mailboxDate[this.activeName - 1].id,logMenuName:localStorage.logMenuName,logMenuCode:localStorage.logMenuCode}).then(res => {
        if (res.code === 0) {
          // this.$message({ message: res.msg, type: 'success' })
          // this.getInfo()
          this.mailboxDate[this.activeName - 1].readStatus = 1
        } else {
          this.$message({ message: res.msg, type: 'error' })
        }
      }, err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.home-layout-root
  min-height 100vh
  box-sizing border-box
  background-color var(--layout-canvas-bg, #f0f2f5)
  background-image var(--layout-canvas-gradient)
  background-repeat no-repeat
  background-position center
  background-attachment fixed
  background-size cover

.left_title
  height 40px
  line-height 40px
  background-color rgb(187,214,248)
.top_item
  height 100%
  margin-right 5px
  margin-left 10px
  border 1px solid #bbd6f8
.left_content_item
  height 30px
  text-align center
  line-height 30px
  font-size 16px
  border-bottom 1px solid #bbd6f8
.bold
  font-weight 700
.data_title_left
  display block
  text-align center
.data_title_right
  display block
  border-left 1px solid #bbd6f8
  text-align center
</style>



// WEBPACK FOOTER //
// src/views/Home.vue